@if (AnswerType.None === answer()) {
  <p class="feedback__question fw-bold fst-italic">
    {{ feedbackSettings().title }}
  </p>
  <div class="feedback__buttons">
    <crnt-button
      variant="tertiary"
      wlAutomationId="feedback-affirm"
      trackInteraction="click"
      interactionCategory="feedback"
      [interactionData]="{
        type: 'faq',
        name: question,
        feedback: affirmativeText,
        question: 'CFS',
      }"
      (click)="onAnswer(AnswerType.Affirmed)"
    >
      <crnt-icon slot="leading" icon="check" />
      <span>{{ affirmativeText }}</span>
    </crnt-button>
    <crnt-button
      variant="tertiary"
      wlAutomationId="feedback-deny"
      trackInteraction="click"
      interactionCategory="feedback"
      [interactionData]="{
        type: 'faq',
        name: question,
        feedback: denyingText,
        question: 'CFS',
      }"
      (click)="onAnswer(AnswerType.Denied)"
    >
      <crnt-icon slot="leading" icon="xmark" />
      <span>{{ denyingText }}</span>
    </crnt-button>
  </div>
}

@if (AnswerType.Affirmed === answer()) {
  <p class="fw-bold fst-italic">
    {{ feedbackSettings().affirmativeFeedbackText }}
  </p>
}

@if (AnswerType.Denied === answer()) {
  <p class="fw-bold fst-italic">{{ feedbackSettings().denyingFeedbackText }}</p>
  <a
    [href]="feedbackSettings().contactUrl"
    trackInteraction="click"
    interactionCategory="feedback"
    [interactionData]="{
      type: 'faq',
      name: feedbackSettings().title,
      feedback: 'contact',
      question: 'escape',
    }"
  >
    <span>{{ feedbackSettings().contactText }}</span>
  </a>
}
